import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const ProcessingPage = lazy(() => import('@/pages/processing/ui/index'))

export const Route = createFileRoute('/_protected/processing')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <ProcessingPage />
    </Suspense>
  ),
})
